import * as React from "react";
import type { LucideIcon } from "lucide-react";
import { toast } from "react-toastify";
import { UserAvatar } from "@/components/ui/userAvatar";
import { emptyUserData } from "@/hooks/use-authenticated-user";
import { useGetDirectoryUserQuery } from "@/api/users-admin";
import type { SharePermission } from "@/components/share/types";

interface Props {
  permission: SharePermission;
  canRemove: boolean;
  onRemove: () => Promise<void>;
  RemoveIcon: LucideIcon;
}

export const ShareUserRow: React.FC<Props> = ({ permission, canRemove, onRemove, RemoveIcon }) => {
  const { data: user = emptyUserData, isLoading } = useGetDirectoryUserQuery(permission.user_id);

  const handleRemove = async () => {
    if (!canRemove) {
      return;
    }
    await onRemove();
    toast.success("Permissions has been updated successfully.");
  };

  if (isLoading) {
    return null;
  }

  return (
    <div className="mb-3 flex items-center py-1">
      <UserAvatar user={user} identifier={permission.user_id} size="sm" className="mr-2" />
      <div className="text-sm">
        {user.name || user.email} {user.surname} {user.email && `(${user.email})`}
      </div>
      <div className="ml-auto flex items-center text-sm text-gray-600">
        <span className="capitalize">{permission.role}</span>{" "}
        {canRemove ? (
          <RemoveIcon className="ml-2 h-4 w-4 cursor-pointer text-gray-600" onClick={handleRemove} />
        ) : (
          <RemoveIcon className="ml-2 h-4 w-4 text-gray-300" />
        )}
      </div>
    </div>
  );
};
